import React from "react";
import { Navigate } from "react-router-dom";
import { useCustomer } from "../../Context/Customer/CustomerContext";
import { useBookingSession } from "../../Context/BookingSession/BookingSessionContext";
import { isMobileVerificationValid } from "../../Utils/bookingVerification";

export const RequireBookingVerification = ({ children }) => {
  const { bookingID } = useBookingSession();
  const { formData, isUserVerified, verifiedMobile } = useCustomer();
  const canContinue = isMobileVerificationValid({
    isUserVerified,
    verifiedMobile,
    currentMobile: formData.mobile,
  });

  // Return to the previous booking step before mounting the contact form.
  if (!bookingID) {
    return <Navigate to="/review-and-confirm-booking" replace />;
  }

  if (!canContinue) {
    return <Navigate to="/verify-identity" replace />;
  }

  return children;
};
